module.exports = __webpack_public_path__ + "img/bulle_4_choix_metier.00185b78.png";